export const detectEmployeeIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete employee" || cleaned === "remove employee") {
        return { intent: "delete_employee" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) employee/);
    if (deleteMatch) {
        return { intent: "delete_employee", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create employee") || cleaned.includes("add employee")) {
        return { intent: "create_employee" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create employee named (.+)/);
    if (createMatch) {
        return { intent: "create_employee", name: createMatch[1].trim() };
    }

    return null;
};
